import { canv } from "@/canv/global.js";
import type { ShapeTextPart } from "../shape";
import { Shape } from "../shape";

export class ShapeLinedDocument extends Shape {
    width = 200;
    height = 148;

    fitText(
        textPart: ShapeTextPart,
        x: number,
        y: number,
        width: number,
        height: number,
        verticalPadding: number,
        horizontalPadding: number,
    ) {
        const allowedWidth = width / 2 - 2 * horizontalPadding;
        const allowedHeight = (height * 5) / 6 - 2 * verticalPadding;

        textPart.hardWidth = allowedWidth;
        textPart.fitShape();

        textPart.startX = x + width / 2 - textPart.width / 2;
        textPart.startY =
            y + this.getTextLineHeight(textPart) + (height * 5) / 6 / 2 - textPart.height / 2;

        this.updateTextDims(textPart);

        return {
            allowedWidth: allowedWidth,
            allowedHeight: allowedHeight,
        };
    }

    draw(x: number, y: number, width: number, height: number, drawVerticalLine = true) {
        let r = height / 20;

        if (width < 2 * r) r = width / 2;

        canv.ctx.beginPath();
        canv.ctx.moveTo(x, y + r);
        canv.ctx.arcTo(x, y, x + width, y, r);
        canv.ctx.arcTo(x + width, y, x + width, y + height, r);
        canv.ctx.lineTo(x + width, y + height * 0.88);

        let r2 = height / 5;

        if (width < 5 * r2) r2 = width / 5;

        canv.ctx.bezierCurveTo(
            x + width * 0.67,
            y + height * 0.55,
            x + width * 0.4,
            y + height * 1.3,
            x,
            y + (height * 5) / 6,
        );
        canv.ctx.lineTo(x, y + (height * 5) / 6);
        canv.ctx.lineTo(x, y + r);

        if (drawVerticalLine) {
            canv.ctx.moveTo(x + width * 0.21, y + height * 0.98);
            canv.ctx.lineTo(x + width * 0.21, y);
        }

        canv.ctx.closePath();
    }

    getView(reason = "shapeToolSubMenu", bgColor = "white", borderColor = "black") {
        let width = 25;
        let height = 25;
        let fill = "white";
        let stroke = "black";

        if (reason === "shapeToolSubMenu") {
            width = 24;
            height = 24;
            fill = "transparent";
            stroke = "#7C7C91";
        } else if (reason === "shapeLibrary") {
            width = 30;
            height = 30;
        } else if (reason === "voteResult") {
            width = 170;
            height = 170;
            fill = bgColor;
            stroke = borderColor;
        }

        return `
            <svg width="${width}" height="${height}" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <path fill="${fill}" d="M0 0h24v24H0z"/>
                <path stroke="${stroke}" d="M5.75 4v16M22.58 3.5H1.42a.9.9 0 0 0-.92.89v11.3c0 .21.08.42.22.57.77.82 3.4 3.47 5.78 4.1 4.41 1.15 6.56-4.9 11-3.86 1.49.35 3.14 1.46 4.33 2.4.63.5 1.67.08 1.67-.72V4.38a.9.9 0 0 0-.92-.88Z"/>
            </svg>
        `;
    }
}
